<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="fmh">CONTENTS</p>
<p class="cct"><span href="#/xhtml/title#tit" title="Link target outside of Sample"><span class="epub-bi">Title Page</span></span></p>
<p class="cct-bot"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample"><span class="epub-bi">Dedication</span></span></p>
<p class="cct"><a href="#/xhtml/chapter1#ch1"><span class="epub-bi">One:   </span>Hate Happens</a></p>
<p class="cct"><a href="#/xhtml/chapter2#ch2"><span class="epub-bi">Two:   </span>Why I Have No Friends, Part I</a></p>
<p class="cct"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample"><span class="epub-bi">Three:   </span>Yes, <span class="epub-i">Really</span></span></p>
<p class="cct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample"><span class="epub-bi">Four:   </span>How to Love the Man You Hate</span></p>
<p class="cct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample"><span class="epub-bi">Five:   </span>Hate Your Way to Happiness</span></p>
<p class="cct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample"><span class="epub-bi">Six:   </span>That’s So Great!</span></p>
<p class="cct"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample"><span class="epub-bi">Seven:   </span>How to Hate the Man You Love</span></p>
<p class="cct"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample"><span class="epub-bi">Eight:   </span>Why I Have No Friends, Part II</span></p>
<p class="cct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample"><span class="epub-bi">Nine:   </span>Why Pot Should Be Legal</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><span class="epub-bi">Ten:   </span>The Enemies List</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"><span class="epub-bi">Eleven:   </span>I Hate Your Kids</span></p>
<p class="cct"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample"><span class="epub-bi">Twelve:   </span>Can’t Complain</span></p>
<p class="cct"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample"><span class="epub-bi">Thirteen:   </span>Anger Management</span></p>
<p class="cct-bot"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample"><span class="epub-bi">Epilogue</span></span></p>
<p class="cct"><span href="#/xhtml/notes#not" title="Link target outside of Sample"><span class="epub-bi">Note</span></span></p>
<p class="cct"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample"><span class="epub-bi">Acknowledgments</span></span></p>
<p class="cct"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample"><span class="epub-bi">Also by Valerie Frankel</span></span></p>
<p class="cct"><span href="#/xhtml/copyright#copy" title="Link target outside of Sample"><span class="epub-bi">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2a290902